import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto p-8 bg-light-beige text-lightbg-default">
      <h1 className="text-3xl font-bold my-4">{t("privacy-policy.title")}</h1>

      <p className="my-4">Effective Date: December 7, 2024</p>

      <h2 className="text-xl font-semibold my-4">1. Introduction</h2>

      <p className="my-4">
        Welcome to Promptly Done ("us", "we", or "our"). We are committed to
        protecting your privacy and ensuring the security of your personal
        information. This Privacy Policy explains how we collect, use, and
        disclose your information when you use our website and services.
      </p>

      <h2 className="text-xl font-semibold my-4">2. Information We Collect</h2>

      <p className="my-4">
        We collect information you provide directly to us. For example, when you
        use our prompt generation tool, we collect the information you enter in
        the form fields, such as the type of task, programming language, and
        writing style. We may also collect your IP address and browser
        information for analytical purposes.
      </p>

      <h2 className="text-xl font-semibold my-4">
        3. How We Use Your Information
      </h2>

      <p className="my-4">We use your information to:</p>
      <ul className="list-disc list-inside my-4">
        <li>Provide and improve our services</li>
        <li>Generate AI prompts based on your input</li>
        <li>Analyze website usage and trends</li>
      </ul>

      <h2 className="text-xl font-semibold my-4">
        4. Data Sharing and Disclosure
      </h2>

      <p className="my-4">
        We do not sell or rent your personal information to third parties. We
        may disclose your information in the following circumstances:
      </p>
      <ul className="list-disc list-inside my-4">
        <li>With your consent</li>
        <li>To comply with legal obligations</li>
        <li>To protect our rights and property</li>
      </ul>

      <h2 className="text-xl font-semibold my-4">5. Data Security</h2>

      <p className="my-4">
        We take reasonable measures to protect your information from
        unauthorized access, use, or disclosure. However, no method of
        transmission over the internet or method of electronic storage is
        completely secure.
      </p>

      <h2 className="text-xl font-semibold my-4">6. Children's Privacy</h2>

      <p className="my-4">
        Our services are not intended for children under the age of 13. We do
        not knowingly collect personal information from children under 13.
      </p>

      <h2 className="text-xl font-semibold my-4">
        7. Changes to this Privacy Policy
      </h2>

      <p className="my-4">
        We may update this Privacy Policy from time to time. We will post any
        changes on our website.
      </p>

      <h2 className="text-xl font-semibold my-4">8. Contact Us</h2>

      <p className="my-4">
        If you have any questions about this Privacy Policy, please contact us
        at [your email address].
      </p>
    </div>
  );
};

export default PrivacyPolicy;
